import React, { useState, useEffect } from 'react';
import { Coins } from 'lucide-react';
import { getWallet } from '../lib/apis_vibe';

interface UserWallet {
  id: number;
  user_id: number;
  balance: number;
  total_used: number;
  updated_at: string;
}

interface TokenBalanceProps {
  className?: string;
}

const TokenBalance: React.FC<TokenBalanceProps> = ({ className = '' }) => {
  const [wallet, setWallet] = useState<UserWallet | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWallet();
  }, []);

  const fetchWallet = async () => {
    try {
      setLoading(true);
      const res = await getWallet();
      const data = (res as any).data || res;
      setWallet(data);
    } catch (e) {
      console.error('获取钱包信息失败:', e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className={`flex items-center gap-4 bg-white/5 px-3 py-1.5 rounded-full border border-white/10 text-xs ${className}`}>
        <div className="flex items-center gap-1.5 text-yellow-400 font-medium">
          <Coins size={14} />
          <span>加载中...</span>
        </div>
      </div>
    );
  }

  if (!wallet) {
    return null;
  }

  return (
    <div className={`flex flex-col items-center gap-1 bg-white/5 px-3 py-2 rounded-full border border-white/10 text-xs ${className}`}>
      <div className="text-gray-400">
        已用: <span className="text-gray-300">{wallet.total_used.toLocaleString()}</span>
      </div>
      <div className="flex items-center gap-1.5 text-yellow-400 font-medium">
        <Coins size={14} />
        <span>{wallet.balance.toLocaleString()}</span>
      </div>
    </div>
  );
};

export default TokenBalance;